import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {News} from "../../shared/model/news.model";
import {IonModal, NavController} from "@ionic/angular";
import {CommonService} from "../../shared/service/common.service";
import {FirebaseEventEnum} from "../../shared/enum/firebase-event.enum";
import {FirebaseService} from "../../shared/service/firebase.service";

@Component({
  selector: 'app-news-item',
  templateUrl: './news-item.component.html',
  styleUrls: ['./news-item.component.scss'],
})
export class NewsItemComponent implements OnInit {

  @ViewChild('detailModal') detailModal: IonModal;

  @Input() news: News;
  @Input() type: 'horizontal' | 'vertical' = 'vertical';
  @Input() fullWidth: boolean;
  @Input() showSkeleton: boolean;
  @Input() vediTutte: boolean;

  showLogo: boolean;
  showContain: boolean;

  constructor(public commonService: CommonService,
              private navCtrl: NavController,
              private firebaseService: FirebaseService) {
  }

  ngOnInit() {

    //Gestisco il caso dello skeleton
    if(!this.news){
      return;
    }

    const providerLogo = {
      andrianews: {
        logo: '',//non arrivano mai le immagini, quindi nessun logo da mostrare
        img: 'assets/img/andria-news-logo.png',
        showContain: true
      },
      andriaviva: {
        logo: 'assets/img/andria-viva-logo.jpeg',
        img: '',//ci sono sempre immagini
        showContain: false
      },
      batMagazine: {
        logo: 'assets/img/bat-magazine-logo.png',
        img: 'assets/img/bat-magazine.png',
        showContain: true
      },
      andriaFidelisNews: {
        logo: 'assets/img/tutto-fidelis-logo.png',
        img: '',//ci sono sempre immagini,
        showContain: false
      },
      pugliaCulture: {
        logo: '',//non arrivano mai le immagini, quindi nessun logo da mostrare
        img: 'assets/img/puglia-culture.png',
        showContain: false
      }
    };

    this.showLogo = !!this.news.imageUrl;

    const config = providerLogo[this.news.provider];
    if(!this.showLogo){
      this.news.imageUrl = config?.img;
    }

    this.news.logo = config?.logo;
    this.showContain = config?.showContain;
  }

  async onShare(news: News) {
    await this.commonService.share({
      title: news.title,
      url: news.link,
      dialogTitle: 'Condivisi notizia',
      text: news.description
    })
  }

  onOpenExternalNews() {
    this.commonService.onOpenLinkBrowser(this.news.link);
    this.firebaseService.logEvent(FirebaseEventEnum.CLICK_NEWS_EXTERNAL, {
      news_title: this.news.title,
      provider: this.news?.provider
    });
  }

  onOpenLink() {

    if (this.vediTutte) {
      this.navCtrl.navigateForward(['/news']);
      return;
    }

    this.detailModal.present();
    this.firebaseService.logEvent(FirebaseEventEnum.CLICK_NEWS, {
      news_title: this.news.title,
      provider: this.news?.provider
    });
  }

}
